// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1Sz-s","choiceBoxes":"toolbarselects_choiceBoxes__3cFDf","simpleField":"toolbarselects_simpleField__NPAK1"};